import { useEffectOnce } from '@carvana/merch-react-hooks';
import useShowTradeIncentives from '~/hooks/common/selectors/useShowTradeIncentives';
import useFireTradeIncentiveEvents from '~/hooks/common/telemetry/useFireTradeIncentiveEvents';

export default function useSendTradeIncentiveEvents() {
  const sendEvent = useShowTradeIncentives();
  const fireEvents = useFireTradeIncentiveEvents();

  useEffectOnce(
    () => {
      fireEvents('srp');
    },
    [fireEvents],
    sendEvent
  );
}
